export const WEEKEND = "Weekend";
export const QUALIFYING = "Qualifying";
export const RACE = "Race";
export const SPRINT = "Sprint";

export const DRIVER = "DRIVER";
export const CONSTRUCTOR = "CONSTRUCTOR";
